import { render, staticRenderFns } from "./carousel-nav.vue?vue&type=template&id=5e2ec064"
import script from "./carousel-nav.vue?vue&type=script&lang=js"
export * from "./carousel-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports